import React, { Component } from "react";
import { productJson, displayUseCase } from "../useCases";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";
import { Button } from "react-bootstrap";

class PreviewSidebar extends Component {
    componentDidMount(){
        const toggleBtn = document.querySelector('.publish_toggle_icon');
        const sidebar = document.querySelector('.preview_sidebar');
          toggleBtn.addEventListener('click', (event)=>{
            sidebar.classList.toggle('open_sidebar');
          });
    }
    render() {
        const { useCase, selectProduct, selectUseCase, step, product, userData, themeId } = this.props;
        const selectedUseCase = product == 'display' ? step > 1 ? useCase : product : product;
        const json = product == "display" ? step > 1 ? displayUseCase : productJson : productJson;
        const action = (product == "display" && step > 1) ? selectUseCase : selectProduct; 
        const virtualEvent = userData ? userData.user && Object.keys(userData.user) ? userData.user.virtualEvent : 0 : 0;

        return <div className="preview_sidebar">
            <Button variant="" className="p-0 publish_toggle_icon border-0" data-factors-form-bind="true" data-factors-click-bind="true">
                <FontAwesomeIcon type={'solid'} icon={'angles-right'} iconClass={''} />
            </Button>
            <div className="preview_sidebar_area">
                <div className="">
                    <p className=""><strong>Select Platform</strong></p>
                    <ul className="preview-tabs nav flex-wrap p-0 flex-column">
                        {json.map((item, index) => 
                        ((item.value != 'events') || (item.value == 'events' && virtualEvent))?
                        (![74, 75, 76, 77].includes(themeId) ) ?  
                        <li className="nav-item d-flex flex-column mb-3" key={`${item.productName}-${index}`} onClick={() => action(item.value, index)}>
                            <button className={`nav-link d-flex align-items-center rounded py-0 bg-transparent ${(selectedUseCase == item.value) ? 'active' : ''}`}>
                                <span className="w-100 d-flex align-items-center justify-content-between position-relative">
                                    <span className="w-100 d-flex align-items-center">
                                        <span className="tab-svg-icon me-2">
                                            {item.icon}
                                        </span>
                                        <span>{item.productName}</span>
                                    </span>
                                    <span className="">
                                        <FontAwesomeIcon type={'light'} icon={'angle-right'} iconClass={''} />
                                    </span>
                                </span>
                            </button>
                        </li>
                        :  item.productName != 'Website' ?
                        <li className="nav-item d-flex flex-column mb-4" key={`${item.productName}-${index}`} onClick={() => action(item.value, index)}>
                            <button className={`nav-link d-flex align-items-center rounded py-0 bg-transparent ${(selectedUseCase == item.value) ? 'active' : ''}`}>
                                <span className="w-100 d-flex align-items-center justify-content-between position-relative">
                                    <span className="w-100 d-flex align-items-center">
                                        <span className="tab-svg-icon me-2">
                                            {item.icon}
                                        </span>
                                        <span>{item.productName}</span>
                                    </span>
                                    <span className="">
                                        <FontAwesomeIcon type={'light'} icon={'angle-right'} iconClass={''} />
                                    </span>
                                </span>
                            </button>
                        </li> : null
                        : null)}
                    </ul>
                </div>
                <div className="layout-disc">
                <strong>{useCase ==  'projector' ? 'Projector': useCase ==  'signage'? 'Digital signage' : useCase ==  'events'? 'Virtual events' : useCase ==  'widget'? 'Website' : 'Digital Display'}</strong>

                    <hr/>
                    <p>{useCase ==  'projector' ? 'Showcase live social proof and employee feedback on your displays to increase awareness and understanding.': useCase ==  'Enhance your DOOH ads, digital signages and jumbotrons with real-time social proof and user feedback. '? 'Digital signage' : useCase ==  'events'? 'Virtual events just got social! Spark engagement, ignite conversions with real-time buzz & glowing reviews - all in one place.' : useCase ==  'widget'? 'Inject your website with personality! Showcase your vibrant social buzz, glowing reviews, and engaging content on landing pages, product pages, even your homepage.' : "Don't just display, engage! Integrate social proof & reviews on your digital displays for impactful results. "}</p>
                    <div className="layout-disc-icons">
                        <ul className="d-flex flex-wrap mb-0 p-0">
                            <li>
                                <FontAwesomeIcon type={'solid'} icon={'tv-retro'} iconClass={''} />
                                <p className="mb-0">TV Screen</p>
                            </li>
                            <li>
                                <FontAwesomeIcon type={'regular'} icon={'rectangle-code'} iconClass={''} />
                                <p className="mb-0">Website</p>
                            </li>
                            <li>
                                <FontAwesomeIcon type={'regular'} icon={'projector'} iconClass={''} />
                                <p className="mb-0">Projector</p>
                            </li>
                            <li>
                                <FontAwesomeIcon type={'regular'} icon={'presentation-screen'} iconClass={''} />
                                <p className="mb-0">Digital Signage</p>
                            </li>
                        </ul>
                    </div>
                    {
                        (!useCase && ![74, 75, 76, 77].includes(themeId))&&
                        <>
                            <strong>Website</strong>
                            <hr/>
                            <p>Inject your website with personality! Showcase your vibrant social buzz, glowing reviews, and engaging content on landing pages, product pages, even your homepage.</p>
                        </>
                    }
                </div>
            </div>
        </div>
    }
}
const mapStateToProps = (state) => ({
    userData: state.authenticated.userData
});

export default connect(mapStateToProps)(PreviewSidebar);